import { API, authClient } from '../index';

// Get all reviews entries
export const getReviews = (params) => authClient().get(`${API}/review${params}`);
